import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
import DriverBenefit from './driver-benefit';

const AuditTrail = React.lazy(() => import('./Audit-trail'));
const TripSummary = React.lazy(() => import('./trip-summary'));

export const HistoryConfig = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/audit-trail',
    element: <AuditTrail />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/trip-summary',
    element: <TripSummary />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/driver-benefit',
    element: <DriverBenefit />,
  },
];
